import "./stylestabs.scss";
import { SHOW_KEYNAME } from '../../../env';
import { Tooltip } from 'antd';

const Infomation = ({ stData = {} as any }) => {
  return (
    <div className="user-info-container position-relative">
      <div className="info-section">
        <div className="avatar-container">
          {stData.cus_gender_name === 'Nữ' ? (
            <div className="avatar">
              <svg xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" textRendering="geometricPrecision" imageRendering="optimizeQuality" fillRule="evenodd" clipRule="evenodd" viewBox="0 0 512 512"><path fill="#D0D0D0" d="M0 0h512v512H0z" /><path fill="#B1B1B1" d="M174.139 280.588c-11.32-3.697-19.915-9.191-25.926-16.341 17.362-6.542 25.352-27.052 26.478-57.757.835-22.826-3.905-41.685 3.882-64.21 15.414-44.591 72.372-59.828 104.114-33.739 24.888-2.654 49.962 10.181 55.377 48.562 4.041 28.659-4.537 58.357 4.509 84.756 3.891 11.359 10.644 20.047 21.213 25.126-6.775 6.479-16.593 10.776-28.368 13.647-9.112 2.225-25.572 3.932-44.737 4.953v13.44l18.649 24.916-53.361 42.435-53.299-42.057 14.238-23.909v-14.445c-18.584-.88-34.318-2.619-42.769-5.377zm160.831 64.768c-8.26-16.581-18.734-30.641-30.926-43.854 22.977 8.89 50.179 17.669 67.564 28.573 11.06 6.933 16.776 12.157 21.25 20.55 11.016 20.66 9.396 43.614 15.285 65.592H103.856c5.885-21.978 4.266-44.932 15.286-65.592 4.474-8.393 10.186-13.617 21.25-20.55 17.38-10.904 44.582-19.683 67.564-28.573-12.192 13.213-22.666 27.273-30.93 43.854l23.926-.586 53.716 42.901 56.375-42.901 23.927.586z" /></svg>
            </div>
          ) : (
            <div className="avatar">
              <svg xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" textRendering="geometricPrecision" imageRendering="optimizeQuality" fillRule="evenodd" clipRule="evenodd" viewBox="0 0 512 512"><path fill="#D0D0D0" d="M0 0h512v512H0z" /><path fill="#B1B1B1" d="M86.655 416.22c7.264-94.069 37.323-70.129 106.837-113.622 21.47 44.795 108.726 48.051 126.619 0 59.99 38.35 105.701 16.656 105.23 113.622H86.655zm123.222-117.155c-.926-1.202 2.423-9.452 3.216-10.787-9.081-8.081-16.258-16.235-17.788-33.013l-.973.02c-2.249-.03-4.418-.547-6.449-1.704-3.252-1.85-5.539-5.025-7.084-8.606-3.27-7.514-14.042-32.452 2.37-30.481-9.177-17.137 11.592-46.413-24.228-57.241 29.389-37.222 91.398-94.614 136.841-37.044 49.739 4.82 65.255 63.932 31.762 96.307 1.962.071 3.811.523 5.448 1.399 6.226 3.335 6.43 10.574 4.794 16.646-1.619 5.073-3.676 8.505-5.614 13.45-2.359 6.676-5.806 7.919-12.467 7.2-.338 16.507-7.967 24.609-18.233 34.307l2.809 9.517c-13.767 29.202-70.958 30.377-94.404.03z" /></svg>
            </div>
          )}
        </div>
        <div className="info-content">
          <label className="info-label font-light">{stData.cus_type_name === 'Đơn vị, tổ chức' ? 'Tên công ty' : 'Họ và tên'}</label>
          <div className="info-value font-medium" {...(SHOW_KEYNAME === true && { 'col-id': 'cus_name' })}>{stData.cus_name[0]}</div>
        </div>
      </div>

      <div className="info-section">
        <div className="info-content">
          <label className="info-label font-light">Mã định danh khách hàng</label>
          <div className="info-value font-medium" {...(SHOW_KEYNAME === true && { 'col-id': 'cus_crm' })}>{stData.cus_crm}</div>
        </div>
      </div>

      <div className="info-section">
        <div className="info-content">
          <label className="info-label font-light">Số điện thoại</label>
          <div className="info-value font-medium action-icons">
            <span {...(SHOW_KEYNAME === true && { 'col-id': 'cus_tel' })}>{stData.cus_tel[0]}</span>
            {/* {stData.cus_tax_reg_no_dms && <span className="company-tag font-light">(Công ty)</span>} */}
            {stData.cus_tel && stData.cus_tel.length > 1 &&
              <Tooltip placement="rightBottom" arrow={false} title={stData.cus_tel.map((tel: any, index: number) => (
                <div key={index}>{tel}</div>
              ))}>
                <div className="action-icons action-icons-bage px-2">
                  <div className="font-light color-bage">{stData.cus_tel.length}</div>
                </div>
              </Tooltip>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default Infomation;
